module.exports = __webpack_public_path__ + "img/question.ec941e09.png";